export const MPC = 'MPC' as const

export const EVM = 'EVM' as const
